<template>
  <div v-if="user" class="content-bottom">
    <div class="bottom-icon" @click="goHome()" >
      <home-outline-icon />
    </div>
    <div class="bottom-icon" @click="search()" >
      <magnify-icon/>
    </div>
    <div class="bottom-icon" @click="goCart()" >
      <cart-outline-icon />
    </div>
    <!-- <div class="bottom-icon" @click="goOffer()" >
      <book-outline-icon />
    </div> -->
    <div class="bottom-icon" @click="goAccount()" >
      <account-badge />
    </div>
  </div>
</template>

<script>

  import {mapState} from "vuex";
  import HomeOutlineIcon from "vue-material-design-icons/HomeOutline.vue";
  import MagnifyIcon from "vue-material-design-icons/Magnify.vue";
  import CartOutlineIcon from "vue-material-design-icons/CartOutline.vue";
  import BookOutlineIcon from "../../../node_modules/vue-material-design-icons/BookOutline.vue";
  import AccountBadge from "vue-material-design-icons/AccountBadge";

  export default {
    components: {
      BookOutlineIcon,
      CartOutlineIcon,
      MagnifyIcon,
      HomeOutlineIcon,
      AccountBadge},
    methods: {
      goHome() {
        this.$router.replace({ name: 'welcomePage'});
      },
      search() {
        this.$store.dispatch('closeRightWindow');
        this.$store.dispatch('openSearchBlock');
        // this.$router.replace({ name: 'searchPage'});
      },
      goCart() {
        this.$store.dispatch('openRightWindow');
      },
      goOffer() {
        this.$store.dispatch('openRightWindowOffer');
      },
      goAccount() {
        this.$router.replace({ name: 'account'});
      }
    },
    computed: {
      ...mapState({
        user: state => state.user.authorizedUser,
      })
    },

    beforeMount() {
    },

  }
</script>




// WEBPACK FOOTER //
// src/components/template/BottomMobilePanel.vue